/* @flow */

import { compose } from 'ramda';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getEventId } from '@e180/domain/lib/event/util';

import SignupProfileWizardDumb from './SignupProfileWizardDumb';
import {
  showSignupAboutForm,
  showSignupAvatarForm,
  markSignupAsComplete,
  markSignupAsIncomplete,
} from 'src/shared/app/signup/action/signupActions';
import {
  getSignupI18nFields,
  getSignupExtraFields,
} from 'plugin/signup/util/signupUtils';
import { isSignupAvatarFormShown } from 'src/shared/app/signup/selector/uiSignupSelector';
import { throwFormikSubmissionError } from 'src/shared/app/base/form/util/formUtil';
import { getRoutePath } from 'src/shared/app/base/route/util/routeUtils';
import { homeRoute } from 'src/shared/app/base/route/setting/routeSettings';
import withMount from 'src/shared/app/base/component/hoc/withMount';
import { patchSelf } from 'src/shared/domain/user/action/userActions';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';
import { patchMembership } from 'src/shared/domain/membership/action/membershipActions';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  // Self passed
  history: Object,
  intl: intlShape,
};

const mapStateToProps = (state: State): Object => ({
  isAvatarShown: isSignupAvatarFormShown(state),
  event: getEventSafely(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { history, intl }: Props,
): Object => {
  const { locale } = intl;
  const { event } = stateProps;

  const eventId = getEventId(event);

  return {
    ...stateProps,
    handleMount() {
      dispatch(markSignupAsIncomplete());
    },
    handleAboutSubmit(values: Object) {
      const { firstName, lastName } = values;

      const i18nFields = getSignupI18nFields(event) || null;
      const i18nValues = {};

      if (i18nFields) {
        i18nFields.forEach(({ name }) => (i18nValues[name] = values[name]));
      }

      const preferencesValues = {};
      const flagsValues = {};

      const extraFields = getSignupExtraFields(event) || null;

      if (extraFields) {
        extraFields.forEach(({ name, type }) => {
          if (type === 'checkbox') {
            flagsValues[`signup_${name}`] = values[name];
          } else {
            preferencesValues[`signup_${name}`] = values[name];
          }
        });
      }

      return dispatch(
        patchSelf({
          first_name: firstName,
          last_name: lastName,
          body: {
            [locale]: i18nValues,
          },
        }),
      )
        .then(
          preferencesValues || flagsValues
            ? dispatch(
                patchMembership(eventId, {
                  preferences: preferencesValues,
                  flags: flagsValues,
                }),
              )
            : null,
        )
        .then(dispatch(showSignupAvatarForm()))
        .catch((e) => throwFormikSubmissionError(e));
    },
    handleAvatarBack() {
      dispatch(showSignupAboutForm());
    },
    handleAvatarSubmit() {
      dispatch(markSignupAsComplete());

      history.push(getRoutePath(homeRoute));
    },
  };
};

export default compose(
  injectIntl,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withMount,
)(SignupProfileWizardDumb);
